const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"pressio-condensed",serif',

  primaryColor: '#ed1c24',
  fontColor: '#454949',
  bgColor: '#ebebeb',
  redColor : '#ed1c24',
  darkRecColor : '#cb141b',
  greyColor : '#d9d9d9',
  ...overloading
}
export default variables;